import React, { useEffect, useState } from "react";
import { icon } from "../../config";
import { FORM_ICON } from "./FormsConstant";
import "./styles/ComponentLibrary.scss";

/**
 * Component Library
 * Contains essential form components that can be dragged to the canvas
 * @author Sarthak Arora
 */
const ComponentLibrary = ({ searchTerm = "" }) => {
  const [expandLibrary, setExpandLibrary] = useState(true);

  // Essential form components only
  const formComponents = [
    {
      id: "text-label",
      name: "Text",
      icon: "TEXT",
      description: "Simple text block",
    },
    {
      id: "advanced-text",
      name: "Advanced Text Editor",
      icon: "ADVANCED_TEXT",
      description: "Formatted paragraphs, links & images",
    },
    {
      id: "table",
      name: "Table",
      icon: "TABLE",
      description: "Collect tabular input",
    },

    {
      id: "row-container",
      name: "Grid Layout",
      icon: "COLUMNS",
      description: "Divide form into rows & columns",
    },
    {
      id: "file-upload",
      name: "File Upload",
      icon: "FILE",
      description: "Accept user uploads",
    },
    {
      id: "horizontal-line",
      name: "Divider",
      icon: "DIVIDER",
      description: "Visual divider",
    },
  ];

  const handleDragStart = (event, component) => {
    event.dataTransfer.setData("component", JSON.stringify({ ...component }));
    event.dataTransfer.effectAllowed = "copy";
  };

  // Filter components based on searchTerm
  const filteredComponents = searchTerm
    ? formComponents.filter(
        (component) =>
          component.name?.toLowerCase().includes(searchTerm.toLowerCase()) || component.description?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : formComponents;

  return (
    <aside className='component-library d-flex flex-column overflow-y-auto'>
      <div className='library-header'>
        <h3 className='library-title d-flex align-items-center justify-content-between'>
          UI Components
          <span className='cursor-pointer text-right' onClick={() => setExpandLibrary(!expandLibrary)}>
            {expandLibrary ? icon.CHEVRON_UP : icon.CHEVRON_DOWN}
          </span>
        </h3>
      </div>
      {/* Components List */}
      {expandLibrary && (
        <div className='components-list'>
          {filteredComponents.length > 0 ? (
            filteredComponents.map((component) => (
              <div
                key={component.id}
                className={`component-item ${component.id === "image" ? "component-item--disabled" : ""}`}
                draggable={component.id !== "image"}
                onDragStart={component.id !== "image" ? (e) => handleDragStart(e, component) : undefined}>
                <div className='component-icon'>{FORM_ICON[component.icon]}</div>
                <div className='component-content'>
                  <span className='component-name'>{component.name}</span>
                  <span className='component-description'>{component.description}</span>
                </div>
              </div>
            ))
          ) : (
            <div className='text-muted text-center p-3'>No components found</div>
          )}
        </div>
      )}
    </aside>
  );
};

export default ComponentLibrary;
